import { useCallback, useMemo } from 'react';
import info from '~/assets/icons/info_2.svg';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { rage, useInputAction, useObservable } from '~/rage';
import { InputAction, ModalButtonColor, ModalType } from '~/shared';
import {
	StyledButtonsContainer,
	StyledInfoLabel,
	StyledRow,
	StyledTable,
} from './CarMarketInfoSeller.styled';

const CarMarketInfoSeller = () => {
	const currentAdvert = useObservable(rage.vehicleMarket.getCurrentAdvert());

	const vehicleBrandName = useMemo(() => {
		if (!currentAdvert) return '';
		return rage.vehicles.getVehicleBrandNameByModel(currentAdvert.vehicleModel);
	}, [currentAdvert]);

	const vehicleModelName = useMemo(() => {
		if (!currentAdvert) return '';
		return rage.vehicles.getVehicleModelNameByModel(currentAdvert.vehicleModel);
	}, [currentAdvert]);

	useInputAction(InputAction.CommonMenuClose, () => {
		rage.vehicleMarket
			.exitMenu()
			.catch((err) => rage.notifications.showException(err));
	});

	const handleDelete = useCallback(() => {
		rage.modal.showModal(
			{
				type: ModalType.Default,
				title: 'Подтверждение',
				text: 'Вы действительно хотите снять транспорт с продажи?',
				acceptButton: {
					color: ModalButtonColor.Danger,
					text: 'Снять с продажи',
				},
				cancelButton: {
					color: ModalButtonColor.Secondary,
					text: 'Отменить',
				},
			},
			async (result) => {
				if (result.isAccepted && currentAdvert?.vehicleId) {
					await rage.vehicleMarket.removeAdvert(currentAdvert.vehicleId);
					await rage.vehicleMarket.exitMenu();
				}
			},
		);
	}, [currentAdvert]);

	return (
		<div>
			<StyledInfoLabel>
				<img src={info} />
				<Text>Информация о транспорте</Text>
			</StyledInfoLabel>
			<StyledTable>
				<StyledRow>
					<Text>Марка</Text>
					<Text>{vehicleBrandName}</Text>
				</StyledRow>
				<StyledRow>
					<Text>Модель</Text>
					<Text>{vehicleModelName}</Text>
				</StyledRow>
				<StyledRow>
					<Text>Владелец</Text>
					<Text>{currentAdvert?.ownerNickname}</Text>
				</StyledRow>
				<StyledRow>
					<Text>Пробег</Text>
					<Text>
						{currentAdvert?.mileage?.toLocaleString('ru-RU') ?? 0} км.
					</Text>
				</StyledRow>
				<StyledRow>
					<Text>Кол-во владельцев</Text>
					<Text>{currentAdvert?.ownersCount ?? 0} чел.</Text>
				</StyledRow>
			</StyledTable>
			<StyledButtonsContainer>
				<Button
					color={ButtonColors.Default}
					onClick={() => rage.vehicleMarket.exitMenu()}
					height={ButtonHeight.Height50}
				>
					<Text>Отменить</Text>
				</Button>
				<Button
					color={ButtonColors.Cancel}
					onClick={handleDelete}
					height={ButtonHeight.Height50}
				>
					<Text>Снять с продажи</Text>
				</Button>
			</StyledButtonsContainer>
		</div>
	);
};

export { CarMarketInfoSeller };
